
import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { FormField, FormItem, FormControl, FormLabel, FormMessage } from '@/components/ui/form';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { CreditCard, ArrowRight } from 'lucide-react';
import { OrderFormValues } from '../orderFormSchema';
import TermsPrivacyDialog from '../TermsPrivacyDialog';

interface TermsAndPaymentProps {
  form: UseFormReturn<OrderFormValues>;
  isLoading: boolean;
}

const TermsAndPayment: React.FC<TermsAndPaymentProps> = ({ form, isLoading }) => {
  return (
    <div className="space-y-6">
      <FormField
        control={form.control}
        name="agreeTerms"
        render={({ field }) => (
          <FormItem className="flex flex-row items-start space-x-3 space-y-0 rounded-md border p-4">
            <FormControl>
              <input
                type="checkbox"
                checked={field.value}
                onChange={field.onChange}
                className="h-4 w-4 mt-1"
              />
            </FormControl>
            <div className="space-y-1 leading-none">
              <FormLabel>
                I agree to the{" "}
                <TermsPrivacyDialog type="terms">
                  <span className="text-blue-600 hover:underline cursor-pointer">
                    terms of service
                  </span>
                </TermsPrivacyDialog>{" "}
                and{" "}
                <TermsPrivacyDialog type="privacy">
                  <span className="text-blue-600 hover:underline cursor-pointer">
                    privacy policy
                  </span>
                </TermsPrivacyDialog>
              </FormLabel>
              <FormMessage />
            </div>
          </FormItem>
        )}
      />
      
      <Alert className="bg-blue-50 border-blue-200">
        <CreditCard className="h-4 w-4 text-blue-600" />
        <AlertTitle className="text-blue-800">Secure Payment</AlertTitle>
        <AlertDescription className="text-blue-700">
          You'll be redirected to our secure payment processor after submitting this form.
        </AlertDescription>
      </Alert>
      
      <Button
        type="submit"
        className="w-full bg-primary-blue hover:bg-blue-700"
        disabled={isLoading}
      >
        {isLoading ? "Processing..." : "Proceed to Payment"}
        {!isLoading && <ArrowRight className="ml-2 h-4 w-4" />}
      </Button>
    </div>
  );
};

export default TermsAndPayment;
